import React from 'react'
import styles from './style.module.scss'

interface RecurrenceDescriptionDisplayProps {
  description: string | null
}

const RecurrenceDescriptionDisplay: React.FC<RecurrenceDescriptionDisplayProps> = ({
  description,
}) => {
  if (!description) return null

  return (
    <div className={styles.recurrenceDescriptionDisplay}>
      <span className={styles.rruleLabel}>{description}</span>
    </div>
  )
}

export default RecurrenceDescriptionDisplay
